
import React from 'react';
import api from "../../../services/api";
import { NavLink } from 'react-router-dom';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import './../../../pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro/styles.css';
import { user_token } from '../../../services/Auth';
import "./style.css";
import Grid from '@material-ui/core/Grid';
import SideNav from '../../../components/SideNav';

var token = localStorage.getItem(user_token);

export default class PedidoInstituiçao extends React.Component {

    state = {
        instituicao: [],
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {
        const { id } = this.props.match.params;
        console.log(id);
        const request = await api.get(`/agent/${id}`, {headers: {'x-access-token': token}});
        console.log(request);
        console.log(request.data);
        this.setState({ instituicao: request.data });
    
      };

    render() {
        return (
        <>
        <SideNav />
        <div id="top-PS">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
          <Grid item xs={2} sm={2} md={1} lg={1} align="center">     
                <NavLink id="voltar-a" to="/"> <button id="voltar">Voltar</button></NavLink>
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"> 
          </Grid>
        </Grid>
        </div>
          <Grid container spacing={0} direction="row" justify="left"  alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
          <div id="main-RI-Consulta-Pendente">
          <h1 id="title">Pedido da Instituição</h1>
          <br></br>
          <div id="lista-style">
          {this.state.instituicao.map(details => (
          <> 
            <div id="exam">
            <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Representante da Instituição: </p><p>{details.name}</p>
          <p id="RI-Title-Cadastro-Paciente" >Nome da Instituição: </p><p>{details.institucion_name}</p>
          <p id="RI-Title-Cadastro-Paciente" >Telefone do(a) Representante da Instituição: </p><p>{details.phone}</p>
          <p id="RI-Title-Cadastro-Paciente" >E-mail do(a) Representante da Instituição: </p><p>{details.email}</p>
          <p id="RI-Title-Cadastro-Paciente" >Genero do(a) Representante da Instituição: </p><p>{details.gender}</p>
          <p id="RI-Title-Cadastro-Paciente" >Data de nascimento do(a) Representante da Instituição: </p><p>{details.birth}</p>
          <p id="RI-Title-Cadastro-Paciente" >Senha do(a) Representante da Instituição: </p><p>{details.password}</p>
          <p id="RI-Title-Cadastro-Paciente" >Endereço da Instituição: </p><p>{details.institucion_adress}</p>
              </div>
             
            </>
          ))}
        </div>
        </div>
        </Grid>
        </Grid>
      </>
        );
    }
}

/* import React, { useState } from 'react';
import { AiOutlineSearch } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import { Collapse } from "react-collapse";
import { NavLink } from 'react-router-dom'
import './../Tela_Consulta_Pendente/style.css';
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav';


export default function Tela_Consulta_Pendente() {
  let [search, setSearch] = useState(false);
  let [options, setOptions] = useState(false);
  return(
    <>
        <SideNav />
        <div id="cp-top">

        <div id="backbutton">
            <NavLink id="voltar-a" to="/Tela_Consultas"> <button id="voltar">Voltar</button></NavLink>
        </div>

        <div id="searchbutton2">
            <Collapse isOpened={search}>
                <input id="cp-painel" type="text" placeholder="pesquisa..." />
            </Collapse>
            <AiOutlineSearch
                size={"6vh"}
                onClick={() =>
                    setSearch(!search)
                }
                id="Icon-Search-cp-Painel"

            />
        </div>
        </div>

        <div id="main-cp-Painel">
            <div id="actions-cp-Painel">
                <p id="cp-Painel">Detalhe da consulta</p>
                <hr id="divider-cp-Painel" />
                <div id="arrow-cp-Painel">
                    <IoIosArrowDown
                        onClick={() =>
                            setOptions(!options)
                        }
                        size={"6vh"}
                        id="IconDown-cp-Painel"
                    />
                </div>
              <Collapse isOpened={options}>
                  <div id="collapsed-cp_Painel">
                     <p id= "titulodados">DADOS DA CONSULTA</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>Data da consulta: </b>16/04/2020</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>Horário da consulta: </b>14:30</p>
             

                     <p id= "titulodados">DADOS DO PACIENTE</p>
                            <p id="cp-Consultas-Detalhes-Dados"> <b> Nome: </b>Paulo da Silva Sauro</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>CPF: </b>123.456.789-00</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>Idade: </b>18</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>Sexo: </b>Masculino</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>Endereço:</b>Setor Comercial Norte Ed.Brasil 21</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>CEP: </b>12345-678</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>Data da última consulta: </b>16/04/2020</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>Responsável pela última consulta: </b>Renato Portela</p>
                            <p id="cp-Consultas-Detalhes-Dados"><b>Notas de observação:</b>Paciente com restrição a dipirona</p>
     
                  </div>

                    <form id="formsce">
                        <label for="medicos_ce" id="medicos2_ce">Escolha o médico:</label>
                    <select id="medicos3_ce" name="medicos_ce">
                        <option value="Jorgin">Jorge</option>
                        <option value="Ken">Karen</option>
                        <option value="Janete">Janete</option>
                        <option value="Craudinho">Claudio</option>
                    </select>
                    <Grid>
                    <div id= "divpp">
                        <NavLink id="app" to="/"> <button id="pp-button1">Aceitar</button></NavLink>
                        <NavLink id="app" to="/"><button id="pp-button2">Recusar</button></NavLink>
                    </div>
                    </Grid>
                    </form>

              </Collapse>
            </div>
          </div>
    </>
  );
} */